import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zonnewering',
  templateUrl: './zonnewering.component.html',
  styleUrls: ['./zonnewering.component.scss']
})
export class ZonneweringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
